import { useState, CSSProperties } from "react";
import { Slider, Grid, Card, Typography, Container } from "@mui/material";
import {
  AkssaiBanner,
  ContactsUs,
  AkksaiLogo,
  FinacLogoSmall,
  ProjExelLogo,
} from "../../assets/images";
import "./index.scss";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import Toolbar from "@mui/material/Toolbar";

import Button from "@mui/material/Button";

const AccountantPriceEstimator = () => {
  const [values, setValues] = useState<any>({
    expenseWithoutSKU: 100,
    salesWithoutSKU: 100,
    expenseWithSKU: 100,
    salesWithSKU: 100,
    otherEntries: 100,
    manufacturingEntries: 100,
  });

  const prices: any = {
    expenseWithoutSKU: 5,
    salesWithoutSKU: 5,
    expenseWithSKU: 7,
    salesWithSKU: 7,
    otherEntries: 3,
    manufacturingEntries: 8,
  };

  const totalPrice = Object.keys(values).reduce(
    (total, key) => total + values[key] * prices[key],
    0
  );

  const totalCountOfInvoices: number = Object.values(values).reduce(
    (acc: number, el: any) => acc + (el as number),
    0
  );
  const totalPriceVirtualVisit = Math.ceil(totalCountOfInvoices / 100) * 200;
  const totalPriceInOfficeVisit = Math.ceil(totalCountOfInvoices / 100) * 500;
  const handleSliderChange =
    (key: string) => (_: Event, newValue: number | number[]) => {
      setValues({ ...values, [key]: newValue as number });
    };

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  ;
  return (
    <>

      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        {/* Main Content */}

        <div style={{ flex: "1", backgroundColor: "#f3f6f8" }}>
          <div className="header-pricing">
            <Box sx={{ display: "flex" }} className="mb-5">
              <CssBaseline />
              <AppBar component="nav">
                <Toolbar>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ mr: 2, display: { sm: "none" } }}
                  >
                    <img src={ProjExelLogo} alt="ProjExel Logo" className="logo" />
                  </IconButton>

                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ width: "100%" }}
                  >
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ display: { xs: "none", sm: "block" } }}
                    >
                      <img
                        src={ProjExelLogo}
                        alt="ProjExel Logo"
                        className="logo"
                      />
                    </Typography>
                    <Box
                      sx={{ display: { xs: "none", sm: "block" } }}
                      className="mr-2"
                    ></Box>
                  </div>
                  <div className="pr-3">
                    <button
                      className="btn btn-primary "
                      style={{ whiteSpace: "nowrap" }}
                      onClick={() => {
                        window.location.href = "https://akssai.com/sign-up/";
                      }}
                    >
                      Sign Up
                    </button>
                  </div>
                </Toolbar>
              </AppBar>
              <div className="navbar-pricing"></div>
            </Box>
          </div>
          <Grid
            container
            spacing={3}
            className="component-container"
            sx={{
              padding: 0,
              paddingLeft: 0,
              paddingRight: 0,
              "@media (min-width:600px)": {
                padding: "3rem",
              },
            }}
          >
            <Grid item style={{ width: "100%" }}>
              <Card className="pl-5 pr-5 pt-4 pb-4 pricing-card">
                <Typography
                  variant="h4"
                  sx={{
                    marginBottom: "10px",
                    fontSize: "23px",
                    fontWeight: 600,
                    color: "#171c26",
                    textAlign: "left",
                    "@media (max-width: 600px)": {
                      marginTop: "1rem",
                    },
                  }}
                >
                  Pricing
                </Typography>
                <div className="pricing-description" style={{ color: "#6e7491" }}>
                  Get instant pricing for accounting based on your sales, expense,
                  manufacturing and other entries!
                </div>

                <div>
                  <div
                    style={{
                      background: "#262a44",
                      color: "#fff",
                      borderRadius: "6px",
                      gap:'10%'
                    }}
                    className="d-flex justify-content-between mt-4 mb-4 p-3 p-md-4 p-lg-5 flex-column flex-md-row align-items-center"
                  >
                    <div className="mb-3 mb-md-0">
                      <div
                        className="responsive-text"

                      >
                        Total Price for Virtual Accounting
                      </div>
                      <div
                        className="mr-2 price-container"
                        style={{
                          fontSize: "35px",
                          fontWeight: "bold",
                        }}
                      >
                        {" "}
                        ₹ {totalPrice + totalPriceVirtualVisit}
                      </div>
                    </div>
                    <div className="mb-3 mb-md-0" style={{ color: "#fac858" }}>
                      OR
                    </div>
                    <div className="mb-3 mb-md-0">
                      <div
                        className="responsive-text"

                      >
                        Total Price for In-Office Visit
                      </div>
                      <div
                        className="mr-2 price-container"
                        style={{
                          fontSize: "35px",
                          fontWeight: "bold",
                        }}
                      >
                        {" "}
                        ₹ {totalPrice + totalPriceInOfficeVisit}
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <p className="pricing-heading">Select Number of Entries</p>
                  <Grid container spacing={4}>
                    {[
                      {
                        label: "Expenses (Without Inventory)",
                        key: "expenseWithoutSKU",
                      },
                      {
                        label: "Sales (Without Inventory)",
                        key: "salesWithoutSKU",
                      },
                      {
                        label: "Expenses (With Inventory)",
                        key: "expenseWithSKU",
                      },
                      {
                        label: "Sales (With Inventory)",
                        key: "salesWithSKU",
                      },
                      { label: "Other Entries", key: "otherEntries" },
                      {
                        label: "Manufacturing Entries",
                        key: "manufacturingEntries",
                      },
                    ].map(({ label, key }, index) => (
                      <Grid item xs={12} md={6} key={key}>
                        <Typography className="slider-label">{label}</Typography>
                        <div className="slider-container">
                          <Slider
                            value={values[key]}
                            onChange={handleSliderChange(key)}
                            step={1}
                            valueLabelDisplay="on"
                            min={0}
                            max={5000}
                          />
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </Card>
            </Grid>
          </Grid>
        </div>

        {/* Footer */}
        <div
          style={{
            backgroundColor: "#f3f6f8",
            position: "relative",
            width: "100%",
            zIndex: 1000,
          }}
        >
          <img
            src={AkssaiBanner}
            alt="banner"
            className="w-100"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            }}
          />
          <Container
            className="text-center w-100"
            style={{
              color: "white",
              position: "relative",
              zIndex: 1,
              padding: "20px",
            }}
          >
            <p className="pricing-footer-heading">Secure Your Financial Future with Akssai</p>
            <p className="pricing-footer-text">
              Reach out to us for Professional Finance and Accounting Assistance.
            </p>
            <button
              className="btn btn-primary"
              style={{ marginTop: "10px" }}
              onClick={() => {
                window.location.href = "https://akssai.com/sign-up/";
              }}
            >
              Contact us
            </button>
          </Container>
        </div>
      </div>

    </>
  );
};

export default AccountantPriceEstimator;
